<div
  class="custom-snackbar__container"
  data-testid="custom-snackbar__container"
>
  <div class="custom-snackbar__message" data-testid="custom-snackbar__message">
    {{ data.message }}
  </div>
  <div class="custom-snackbar__actions" data-testid="custom-snackbar__actions">
    <a
      href="#"
      class="custom-snackbar__link"
      (click)="onNavigate($event)"
      data-testid="custom-snackbar__link"
    >
      {{ data.btnTitle }}
    </a>
    <button
      mat-icon-button
      (click)="snackBarRef.dismiss()"
      class="custom-snackbar__close-btn"
      data-testid="custom-snackbar__close-btn"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
